import { render, staticRenderFns } from "./ConfirmMailForm.vue?vue&type=template&id=5e48ef00&scoped=true&"
import script from "./ConfirmMailForm.vue?vue&type=script&lang=ts&"
export * from "./ConfirmMailForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e48ef00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCardText,VCardTitle,VFadeTransition})
